import { DESKTOP_SPACING, NATURAL } from "@/theme";
import { FC, memo } from "react";
import { ORDER_STEP, OrderCreateProps } from "./OrderCreate.interface";

import { Heading } from "#/atoms";
import { SelectedOrder } from "../SelectedOrder";
import { StyledOrder } from "./OrderCreate.styled";

const OrderCreate: FC<OrderCreateProps> = ({
  children,
  extraText,
  isAdmin,
  isReadOnly,
  onCreateOrder,
  selectedOrder
}) => {

  const title = 'Create New Order';
  
  return (
    <>
      <StyledOrder showFooter={selectedOrder != null}>
        {!isReadOnly && <Heading scale="h3" fontColor={NATURAL.K} margin={`0 0 ${DESKTOP_SPACING.XXL}px`}>{title}</Heading>}
        {children}
      </StyledOrder>
      {selectedOrder && (
        <SelectedOrder
          activeStep={ORDER_STEP.BOOKING}
          extraText={extraText}
          isAdmin={isAdmin}
          isReadOnly={isReadOnly}
          onSaveOrder={onCreateOrder}
          {...selectedOrder}
        />
      )}
    </>
  );
}

export default memo(OrderCreate);
